import React, { Component } from "react";

class TotalPrice extends Component {
	render() {
		let { basePrice, changeObj } = this.props;
		let additionalPrice = 0;
		if (basePrice && changeObj) {
			// console.log(changeObj.changeObj[0].selectedChoice[0].choice);
			for (let i = 0; i < changeObj.changeObj.length; i++) {
				for (let j = 0; j < changeObj.changeObj[i].selectedChoice.length; j++) {
					additionalPrice +=
						changeObj.changeObj[i].selectedChoice[j].choice.surcharge;
				}
			}
		}

		return (
      <div className="priceSection">
        <span className="totalPrice">
          {/* {console.log(additionalPrice)} */}
          {(additionalPrice + basePrice).toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
          })}
        </span>
        <span>GESAMTPREIS</span>
      </div>
    );
	}
}

export default TotalPrice;
